import { addBreadcrumb, captureException } from '@sentry/browser'
import { flatten, isValiError, parse } from 'valibot'
import { useAuthPlayerIdSignal } from '../../../../rx/signal/useAuthPlayerIdSignal'
import { useActionLogsSignal } from '../../../../rx/signal/useActionLogsSignal'
import { setAlertBagError } from '../../../../rx/store/AlertBag'
import { getEngineAlertBag } from '../../../three/fn/getSetEngineAlertBag'
import { getEngineToast } from '../../../three/fn/getSetEngineToast'
import { Engine } from '../../engine/Engine.type'
import { StateSchema } from '../State.type'
import Action from './action/Action.type'
import type ActionHandler from './ActionHandler.type'
import actionHandlersList, { type ActionSchemaUnion } from './actionHandlersList.generated'
import type { ActionLog } from './ActionLog.type'

// let lastClientDispatch: Promise<unknown> | null = null
export default async function dispatchReplay(engine: Engine, action: Action, cref: number): Promise<void> {
  const [getAuthPlayerId] = useAuthPlayerIdSignal(engine)
  const [getActionLogs, setActionLogs] = useActionLogsSignal(engine)
  // console.log('dispatchReplay', {
  //   authPlayerId: getAuthPlayerId(),
  //   players: engine.state.players.map((p) => ({
  //     player_id: p.id,
  //     profile_id: p.profile_id,
  //   }))
  // })

  const toast = getEngineToast(engine)
  const ab = getEngineAlertBag(engine)

  addBreadcrumb({
    category: 'action',
    level: 'info',
    data: {
      action,
    },
  })
  // if (isServer) {
  //   throw new Error('dispatchReplay is only available on the client')
  // }
  try {
    // const handler = actionHandlersList.get(action.type)
    const tuple = actionHandlersList.find((t) => action.type === t[0])
    if (tuple) {
      // const actionType = tuple[0]
      const actionSchema: ActionSchemaUnion = tuple[1]
      const actionHandler: ActionHandler = tuple[2]
      const validatedAction = parse(actionSchema, action)
      // await actionHandler(engine, validatedAction)

      const { state : { round } } = engine

      const actionLog : ActionLog = {
        cref,
        round,
        player_id: getAuthPlayerId(),
        at: Date.now(),
        action: validatedAction,
      }

      await actionHandler(engine, validatedAction, actionLog)

      engine.state = parse(StateSchema, engine.state)

      setActionLogs([...getActionLogs(), actionLog])
    } else {
      throw new Error(`Action ${action.type} is not supported`)
    }
  } catch (err) {
    const msg: string = (err as { message?: string }).message || 'unknown'
    const context: Record<string, unknown> = {
      action,
    }
    if (isValiError(err)) {
      context.errors = flatten(err.issues)
    }
    const err2 = new Error(`Action Failed: ${msg}`, { cause: err })
    console.error(err, context)
    captureException(err, context)
    if (toast) {
      toast.error(msg)
    }
    if (ab) {
      setAlertBagError(ab, err2)
    }
  }
}
